import { DocumentType } from '../models/EnumEntity';

const ValidateCUIT = (documentNumber) => {
    if (!documentNumber || documentNumber?.trim().length !== 11)
        return false;

    const multiples = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    const result = documentNumber.toString().split('');
    const sum = multiples.reduce((sum, multiple, index) => sum + (multiple * result[index]), 0)
    const round = Math.ceil((sum / 11 % 1) * 100 / 10);
    const validate = 11 - round === 11 ? 0 : 11 - round === 10 ? 1 : 11 - round;
    return Number(result[result.length - 1]) === validate;
}

const ValidateRUT = (documentNumber) =>
    documentNumber.length > 7 && documentNumber.length <= 21;

const ValidateLength = (documentNumber) =>
    documentNumber?.length >= 7 && documentNumber.length <= 9

const ValidateOther = (documentNumber) =>
    documentNumber?.length >= 7 && documentNumber.length <= 21

const ValidatePassport = (documentNumber) => {
    // const regex = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
    // return regex.test(documentNumber);
    return documentNumber?.length >= 6;
}

const Validator = {
    [DocumentType.CUIT]: ValidateCUIT,
    [DocumentType.RUT]: ValidateRUT,
    [DocumentType.Passport]: ValidatePassport,
    [DocumentType.CI]: ValidateLength,
    [DocumentType.DNI]: ValidateLength,
    [DocumentType.CedulaURY]: ValidateLength,
    [DocumentType.OTHER]: ValidateOther
}

export const DocumentMessageError = {
    [DocumentType.CUIT]: "Numero de CUIT invalido",
    [DocumentType.RUT]: "Numero de RUT debe tener entre 7 y 21 digitos",
    [DocumentType.Passport]: "Numero de Pasaporte debe tener mas de 6 digitos",
    [DocumentType.CI]: "Numero de CI debe tener entre 7 y 9 digitos",
    [DocumentType.DNI]: "Numero de DNI debe tener entre 7 y 9 digitos",
    [DocumentType.CedulaURY]: "Numero debe tener entre 7 y 9 digitos",
    [DocumentType.OTHER]: "Numero de documento debe tener entre 7 y 9 digitos"
}
const IsDocumentValid = (documentType = 'DNI', documentNumber = '') => {
    if (!documentType || !documentNumber) return true;
    return Validator[documentType](documentNumber);
}

export default IsDocumentValid;